"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Heart = _interopRequireDefault(require("../../icons-react/rebrand/Heart"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var WishListButton = function WishListButton(_ref) {
  var onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected;
  var _useState = (0, _react.useState)(isSelected),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isSelectedLocal = _useState2[0],
    setIsSelectedLocal = _useState2[1];
  // локальное состояние для выделения тапа
  (0, _react.useEffect)(function () {
    setIsSelectedLocal(isSelected);
  }, [isSelected]);
  var handleClick = function handleClick(e) {
    setIsSelectedLocal(function (selected) {
      return !selected;
    });
    onClick(e);
  };
  return /*#__PURE__*/_react["default"].createElement(StyledWishListButton, {
    onClick: handleClick,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledHeartIcon, {
    $isMobile: isMobile,
    $isSelected: isSelectedLocal
  }));
};
var StyledHeartIcon = (0, _styledComponents["default"])(_Heart["default"]).withConfig({
  displayName: "WishListButton__StyledHeartIcon",
  componentId: "sc-uq533w-0"
})(["cursor:pointer;height:24px;path{fill:", ";}", ""], function (_ref2) {
  var $isSelected = _ref2.$isSelected;
  return $isSelected ? 'var(--secondary)' : 'var(--grey3)';
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile,
    $isSelected = _ref3.$isSelected;
  return $isMobile && (0, _styledComponents.css)(["stroke:var(--white);stroke-width:2px;stroke-linejoin:round;path{fill:", ";}"], $isSelected ? 'var(--secondary)' : 'transparent');
});
var StyledWishListButton = _styledComponents["default"].div.withConfig({
  displayName: "WishListButton__StyledWishListButton",
  componentId: "sc-uq533w-1"
})(["position:relative;z-index:1;-webkit-tap-highlight-color:transparent;"]);
var _default = exports["default"] = WishListButton;